/**
 * @auth 赖传峰
 * @date 2022/5/5
 */
import { defineNuxtRouteMiddleware, isPikPakClient, useCookie } from '#imports'
import { getIpBlock, type IpBlockRes } from '~/api'
import { useUserInfo } from '~/store/userInfo'
import { StorageKey } from '~/types/enum'
import { DOMAIN_LIST } from '~/types/constants'

const cacheAccessible = () => {
  useCookie(StorageKey.ACCESS_TO_VISIT, {
    path: '/',
    maxAge: 10 * 60,
    sameSite: 'lax',
    secure: true,
  }).value = String(true)
  return undefined
}
const apiAccessible = async (): Promise<IpBlockRes | undefined> => {
  // 尝试所有域名，等待所有接口 fulfilled 或者 rejected
  const resList = await Promise.allSettled(DOMAIN_LIST.map(getIpBlock))

  return resList.some(el => el.status === 'fulfilled' && el.value.data.value?.accessible) ||
    resList.every(el => el.status === 'rejected')
    ? cacheAccessible()
    : (
        resList.find(el => el.status === 'fulfilled' && el.value.data.value?.accessible === false) as
          | PromiseFulfilledResult<ReturnType<typeof getIpBlock>>
          | undefined
      )?.value.data.value
}

// 访问限制，请求接口，获取当前 IP 是否被屏蔽访问
export const ipBlock = async ({
  ignoreCache = false,
}: {
  ignoreCache?: boolean
}): Promise<IpBlockRes | undefined | null> => {
  const getAccessible = async (): Promise<IpBlockRes | undefined> => {
    if (process.dev || (!ignoreCache && useCookie(StorageKey.ACCESS_TO_VISIT).value)) return cacheAccessible()

    return apiAccessible()
  }

  const timeout = () =>
    new Promise((resolve: (val?: null) => void) => {
      ignoreCache ? setTimeout(resolve, 1e4, null) : setTimeout(resolve, 5e3, undefined)
    })

  return Promise.race([getAccessible(), timeout()]).then(val => {
    val !== null && (useUserInfo().ipBlock = val)
    return val
  })
}

export default defineNuxtRouteMiddleware(() => {
  // App 内打开不屏蔽 IP
  if (import.meta.server || isPikPakClient()) return
  ipBlock({ ignoreCache: false })
})
